<div class="row mb-3">
  <div class="col-12">
    <div class="row align-items-center">
      <div class="col-12 col-sm-2 mb-1">
        <label for="reportLanguage">{{
          'serviceData.form.reportLanguage' | translate
        }}</label>
      </div>
      <div class="col-12 col-sm-10">
        <app-select
          formControlName="reportLanguageId"
          name="reportLanguage"
          id="reportLanguage"
          data-cy="ReportLanguage-select"
          [placeholder]="
            partner
              ? partner.reportLanguageIds?.length || partner.languageIds?.length
                ? ('serviceData.form.placeholders.reportLanguage' | translate)
                : ('serviceData.form.placeholders.noReportLanguagesAvailable'
                  | translate)
              : ('serviceData.form.placeholders.selectPartnerFirst' | translate)
          "
        >
          @for (
            language of partner?.reportLanguageIds?.length
              ? partner?.reportLanguageIds
              : partner?.languageIds;
            track language
          ) {
            <app-select-option
              [value]="language"
              [label]="language | displayName: languages()"
            />
          }
        </app-select>
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-10">
        <app-validation-error
          for="reportLanguageId"
          translations="validation.generic"
        ></app-validation-error>
      </div>
    </div>
  </div>
</div>
<ng-container
  *appRequirePermission="id ? ['serviceData.edit.canEditPatientState'] : []"
>
  <ng-container [formGroup]="$any(form.get('serviceInformation.shared'))">
    <div class="row mb-3">
      <div class="col-12">
        <div class="row align-items-center">
          <div class="col-12 col-sm-2 mb-1">
            <label for="patientState">{{
              'serviceData.form.patientState' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-10">
            <textarea
              class="form-control"
              formControlName="comments"
              name="patientState"
              id="patientState"
              data-cy="PatientState-textarea"
              [placeholder]="
                'serviceData.form.placeholders.patientState' | translate
              "
            ></textarea>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-10">
            <app-validation-error
              for="comments"
              translations="validation.generic"
              data-cy="PatientState-validation-error"
            ></app-validation-error>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container
  *appRequirePermission="id ? ['serviceData.edit.canEditNotes'] : []"
>
  <div class="row mb-3">
    <div class="col-12">
      <div class="row align-items-center">
        <div class="col-12 col-sm-2 mb-1">
          <label for="notes">{{ 'serviceData.form.notes' | translate }}</label>
        </div>
        <div class="col-12 col-sm-10">
          <textarea
            class="form-control"
            formControlName="notes"
            name="notes"
            id="notes"
            data-cy="Notes-textarea"
            [placeholder]="'serviceData.form.placeholders.notes' | translate"
          ></textarea>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-10">
          <app-validation-error
            for="notes"
            translations="validation.generic"
            data-cy="Notes-validation-error"
          ></app-validation-error>
        </div>
      </div>
    </div>
  </div>
</ng-container>
